import { camelCase, isArray, isObject, snakeCase, transform } from 'lodash'

export const toCamelCase = (obj, ignoreKeys = []) =>
  transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : (ignoreKeys.includes(key) ? key : camelCase(key))

    acc[camelKey] = isObject(value) ? toCamelCase(value, ignoreKeys) : value
  })

// opaqueKeys: keys whose value is passed through verbatim, with no key
// renaming anywhere in that subtree - for maps like `vars` whose keys are
// meaningful identifiers (e.g. var1) rather than field names, since
// snakeCase() would otherwise mangle them (snakeCase('var1') === 'var_1').
export const toSnakeCase = (obj, ignoreKeys = [], opaqueKeys = []) =>
  transform(obj, (acc, value, key, target) => {
    const snakeKey = isArray(target) ? key : (ignoreKeys.includes(key) ? key : snakeCase(key))

    acc[snakeKey] = opaqueKeys.includes(key)
      ? value
      : (isObject(value) ? toSnakeCase(value, ignoreKeys, opaqueKeys) : value)
  })


export const isFile = (obj) => obj instanceof File

export const isUrl = string => {
  try {
    return Boolean(new URL(string))
  } catch (e) {
    return false
  }
}
